import { Button, cn } from '@nextui-org/react';
import { useEffect, useState } from 'react';

const ToTopButton = ({
  focusInputRef,
}: {
  focusInputRef?: React.RefObject<HTMLInputElement>;
}) => {
  const [showToTop, setShowToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // For example, make header sticky after 100px
      // console.log(window.scrollY)

      // TODO: if (router.pathname !== routes.home) return;
      if (window.scrollY > 900) {
        setShowToTop(true);
      } else {
        setShowToTop(false);
      }
    };

    // Attach the scroll listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Button
      disableRipple
      className={cn(
        'duration-600 fixed z-20 flex max-w-fit select-none items-center gap-1 rounded-full p-1.5 px-2.5 text-xs font-semibold opacity-100 shadow-lg ease-out transition',
        !showToTop ? 'opacity-0' : 'translate-y-6',
        'top-16 left-1/2 -translate-x-1/2 lg:bottom-16 lg:right-16 lg:top-auto lg:mb-16 lg:left-auto'
      )}
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          if (focusInputRef?.current) focusInputRef.current.focus();
        }, 500);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="h-4 w-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
        />
      </svg>
      To Top
    </Button>
  );
};

export default ToTopButton;
